require('./callback.less');
let form = require('../form/form');

import Trackers from '../tracker/tracker';
import PreLoader from '../../modules/preloader';
import { YandexSmartCaptcha } from '../../modules/YandexSmartCaptcha/yandex-smart-captcha';

jQuery(function($) {
    const trackers = new Trackers();
    let contactsPrompt = {
        callback: {
            html: $('.js-callback-forms')
                .remove()
                .html(),
            submit: function(e, v, m) {
                e.preventDefault();
                let callbackForm = m.closest('form');
                trackers.onCallBackButton();
                let params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        callback_phone: {
                            required: true,
                            phoneMask: true
                        },
                        callback_approval: {
                            required: true
                        }
                    },
                    messages: {
                        callback_phone: {
                            required: $.validator.messages.callback_phone.required,
                            phoneMask: $.validator.messages.callback_phone.phoneMask
                        },
                        callback_approval: {
                            required: $.validator.messages.callback_approval.required
                        }
                    },
                    submitHandler: function() {
                        $('.form__captcha-error').removeClass('form__error-msg');
                        $('.form__captcha-error').html(' ');
                        let loader = new PreLoader();
                        loader.show();
                        $.ajax({
                            type: 'POST',
                            url: '/ajax/action/callback_form/callback/',
                            data: callbackForm.serialize(),
                            dataType: 'json',
                            success: function(response) {
                                loader.hide();
                                if (response.code === 200) {
                                    $.prompt.goToState('successCallbackMessage');
                                    trackers.onCallBackRequestSend();
                                    trackers.onPMfrmCallMe();
                                } else {
                                    let errorDiv = $('<div/>', {
                                        class: 'form__error-msg',
                                        text: response.data.error
                                    });
                                    callbackForm.find('.form').prepend(errorDiv);
                                }
                            }
                        });

                    }
                });

                callbackForm.validate(params);
            }
        },

        successCallbackMessage: {
            html: function() {
                return (
                    '  <div class="prompt__content">\n' +
                    '       <p>Сообщение успешно отправлено.</p>\n' +
                    '    </div>'
                );
            }
        }
    };

    $(document).on('click', '.callback__btn', function(e) {
        e.preventDefault();
        trackers.onCallBackFormShow();
        $.prompt(contactsPrompt, {
            initialState: 'callback',
            statechanging: function(e, from, to) {
                if (to !== 'callback') {
                    return;
                }
                new YandexSmartCaptcha('callback_captcha').init();
            }
        });
    });

    $(document).on('click', '.callback__menu', function(e) {
        e.preventDefault();
        trackers.onCallBackFormShow();
        trackers.onPMbtnCallMe();
        //window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
        $.prompt(contactsPrompt, {
            initialState: 'callback',
            statechanging: function(e, from, to) {
                if (to !== 'callback') {
                    return;
                }
                //window.Recaptchafree.render();
                new YandexSmartCaptcha('callback_captcha').init();
            }
        });
    });

    $('.js-feedback-form').submit(function(e) {
        e.preventDefault();
        let $this = $(this);
        let params = $.extend({}, form.formValidateDefaults, {
            rules: {
                feedback_name: { required: true },
                feedback_city: { required: true },
                feedback_phone: {
                    phoneMask: true
                }
            },
            messages: {
                feedback_name: {
                    required: $.validator.messages.feedback_name.required
                },
                feedback_city: {
                    required: $.validator.messages.feedback_city.required
                },
                feedback_phone: {
                    phoneMask: $.validator.messages.feedback_phone.phoneMask
                }
            },
            submitHandler: function() {
                $('.form__captcha-error').removeClass('form__error-msg');
                $('.form__captcha-error').html(' ');
                $.ajax({
                    type: 'POST',
                    url: '/ajax/action/feedback_form/feedback/',
                    data: $this.serialize(),
                    dataType: 'json',
                    success: function(response) {
                        if (response.code == 200) {
                            $('.js-form-reset').trigger('click');
                            $this.find('.form__input--correct').each(function(i, element) {
                                $(element).removeClass('form__input--correct');
                            });
                            trackers.onPMfrmCallMeContact();
                            $.prompt(contactsPrompt, {
                                initialState: 'successFeedbackMessage'
                            });
                        } else {
                            let errorDiv = $('<div/>', {
                                class: 'form__error-msg',
                                text: response.error
                            });
                            $this.find('.form__head-label').after(errorDiv);
                        }
                    }
                });
            }
        });
        $this.validate(params);
        $this.valid();
    });
});



// WEBPACK FOOTER //
// ./blocks/callback/callback.js